import React from 'react'
import { FormContextProvider } from '../../../../../context/formContext'
import Toast from '../../../../../components/Toast/Toast'
import ViewForms from './ViewForms'

const FormsDraftWrapper = () => {
  return (
    <FormContextProvider>
      <Toast />
      <ViewForms />
    </FormContextProvider>
  )
}

export default FormsDraftWrapper
